<template>
    <q-btn
            label="Mark all as read"
            color="primary"
            :loading="isLoading"
            v-bind="$attrs"
            dense flat no-caps
            @click="markAllRead"/>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { HasTaskMixin } from '@/mixins';
import { markAllRead } from './user-notification';

export default defineComponent({
  emits: ['marked-read'],
  mixins: [HasTaskMixin],
  props: {
    userId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    markAllRead(): void {
      this.task = markAllRead(this.userId);
      this.task.then(() => {
        this.$emit('marked-read');
      });
    },
  },
});
</script>
